/**
 * Verbatim copy for the Risks -> "Potential Issues" and Deviations ->
 * "Waivers and Tailoring" renames (SAD-124/SAD-149, decision D8 in
 * major-push/august-roadmap/_decisions.md). This wording is contractual —
 * do not reword, re-punctuate, or re-wrap; change it only alongside a
 * decision-doc update.
 */ export const POTENTIAL_ISSUES_COPY = Object.freeze({
    label: 'Potential Issues',
    sectionInfo: "Internal-only concerns that could impact delivery. Customer-facing program risks stay in your customer's tracker (e.g., Jira) — use this section for what you wouldn't report externally.",
    emptyTitle: 'No potential issues yet',
    emptyDescription: "No potential issues yet. Track internal concerns here before they become issues — anything you'd flag to leadership but not to the customer.",
    probabilityHelp: 'How likely is this to affect delivery?',
    impactHelp: 'Severity if it happens: low, medium, high',
    audienceHelp: 'Who this may be escalated to if it materializes.',
    formerlyCallout: "Formerly 'Risks'",
    convertLabel: 'Convert to Issue',
    convertTooltip: 'This has happened or is now unavoidable. Converting moves it to Issues and carries over owner, links, and history.',
    escalateLabel: 'Escalate to leadership',
    escalateConfirmTitle: 'Escalate to leadership?',
    escalateConfirmDescription: 'This notifies leadership that this potential issue is High probability and High impact. This cannot be undone.',
    escalateAlreadyEscalatedTooltip: 'Leadership has already been notified at the current probability and impact. Change either to escalate again.'
});
/**
 * sectionInfo is split into parts so a component can render `waiver` and
 * `tailoring` inside <strong> without literal asterisks on screen.
 * sectionInfoText carries the same sentence flattened to plain text, for
 * aria-label / title attributes that can't hold markup.
 */ export const WAIVERS_TAILORING_COPY = Object.freeze({
    label: 'Approved Changes',
    sectionInfo: [
        {
            text: 'Approved departures from what the contract or your own process requires. A '
        },
        {
            text: 'government approved change',
            strong: true
        },
        {
            text: ' is one the customer signed off — moving a deliverable, or changing how often it recurs. An '
        },
        {
            text: 'internal process change',
            strong: true
        },
        {
            text: ' is a change to how your team works, recorded so the reason survives.'
        }
    ],
    sectionInfoText: 'Approved departures from what the contract or your own process requires. A government approved change is one the customer signed off — moving a deliverable, or changing how often it recurs. An internal process change is a change to how your team works, recorded so the reason survives.',
    typeHelp: {
        WAIVER: 'The government approved a departure from the contract — a deliverable moves, or its cadence changes. Needs an approval source and contact.',
        TAILORING: "A change to your own internal process, recorded for the record. Doesn't change any contractual date or cadence."
    },
    categoryHelpText: 'Deliverable Due Date Change moves one occurrence to a new approved date. Deliverable Cadence Change alters how often it recurs from here on. Miscellaneous records an approved change against a CLIN without altering any date.',
    approvalSourceHelp: 'Who authorized this departure. Written proof (email or memo) should be attached once evidence attachments land (IDP-13).',
    answeredAtHelp: "When the approval source's answer (Approved or Denied) came back. Independent of any replacement due date — this just records the answer timing.",
    processApprovalEvidenceHelp: 'Process the attached approval email to review its extracted fields. Nothing is applied to this form until you review and accept each proposal.',
    approverNameSuggestionPrefix: 'Evidence names',
    approverNameSuggestionSuffix: 'as the approver — confirm by selecting them in Approval contact above. This name is never applied automatically.',
    unverifiedSenderWarning: 'This approval is attributed to a sender who is not a known contact for this program. An approval from an unverified sender is not a verified approval — confirm their identity before proceeding.',
    approvalBlockedNotice: 'Select the approving contact above before saving. An email alone can never verify who approved this deviation — that confirmation has to be an explicit, human choice.',
    runWarningsIntro: 'Notes from processing this evidence:',
    emptyTitle: 'No approved changes on record',
    emptyDescription: 'No approved changes on record. Log any approved departure from a contractual or process requirement here, with its approval source.'
});
